<template>
  <div class="windDataWrapper">
    <page :setup="setup">
      <container-layout
        :menu="menu"
        @selectMainMenu="selectMainMenu"
        @selectMenu="selectMenu"
        :showAside="false"
        :showActiveIndex="false"
        router
        :defaultMenu="defaultMenu"
      >
        <template v-slot:main>
          <router-view name="content"></router-view>
          <upload-dialog
            :visible="showUpload"
            @close="closeUploadDialog"
          ></upload-dialog>
        </template>
        <template v-slot:upload>
          <div class="menu-right">
            <span @click="openUploadDialog">
              上传
              <i class="el-icon-folder-add"></i>
            </span>
            <span
              v-if="showDownloadTable"
              style="margin-left:10px;"
              @click="downTabel"
            >
              测风报表
              <i class="iconfont icondownload" style="font-size:12px"></i>
            </span>
          </div>
        </template>
      </container-layout>
    </page>
  </div>
</template>

<script>
import loadingMask from '@/components/loading-mask';
import { getToken } from '@/utils/index';
export default {
  data() {
    return {
      showUpload: false,
      defaultMenu: '/wind-data',
      // 左侧menu菜单
      menuLeft: 0,
      menu: [
        // { type: '首页', path: '/wind-data/map' },
        {
          type: '测风塔管理',
          path: '/wind-data/tower-manage'
        },
        {
          type: '数据处理',
          path: '/wind-data/data-process'
        },
        {
          type: '风资源参数分析',
          path: '/wind-data/parameter-analysis'
        },
        {
          type: '测风监控',
          path: '/wind-data/wind-monitor'
        }
      ]
    };
  },
  computed: {
    showDownloadTable() {
      return this.$store.state.WindData.showDownloadTable;
    }
  },
  created() {
    this.getDefaultMenu();
  },
  watch: {
    $route: {
      handler(val) {
        this.getDefaultMenu(val);
      }
    }
  },
  methods: {
    async setup() {
      //console.log('setup');
    },
    selectMenu() {},
    selectMainMenu(menu) {
      this.$store.commit('WindData/SHOW_DOWNLOAD_TABLE', false);
      if (menu === '1') {
        this.$router.push('/public-database');
      }
    },
    closeUploadDialog() {
      this.showUpload = false;
    },
    getDefaultMenu(routes) {
      let { path } = routes || this.$route;
      let item = this.menu.find(item => path.indexOf(item.path) !== -1);
      if (item) {
        this.defaultMenu = item.path;
      }
    },
    openUploadDialog() {
      //console.log(111);
      this.showUpload = true;
    },
    downTabel() {
      this.aswitch = loadingMask({ mask: true });
      let key = getToken();
      let preStr = process.env.VUE_APP_API_HOST_WINDDATA;
      let downLoadApi = `/winddata/tower/report/downExcelReport?apiKey=${key}`;
      let url = preStr + downLoadApi;
      window.open(url, '_parent');
      this.aswitch.close();
    }
  }
};
</script>

<style lang="less">
/deep/.container-layout .container-layout-content > .el-main {
  border: none !important;
}
.windDataWrapper {
  .container-el-main {
    padding: 0 !important;
  }
}
</style>
